var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgStarV1 = function SvgStarV1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.728,
    height: 13.057
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m6.86,0l2.119,4.3l4.745,0.689l-3.432,3.35l0.807,4.721l-4.239,-2.234l-4.24,2.231l0.812,-4.721l-3.432,-3.346l4.745,-0.689l2.115,-4.301z"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMuNzI4IiBoZWlnaHQ9IjEzLjA1NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJtNi44NiwwbDIuMTE5LDQuM2w0Ljc0NSwwLjY4OWwtMy40MzIsMy4zNWwwLjgwNyw0LjcyMWwtNC4yMzksLTIuMjM0bC00LjI0LDIuMjMxbDAuODEyLC00LjcyMWwtMy40MzIsLTMuMzQ2bDQuNzQ1LC0wLjY4OWwyLjExNSwtNC4zMDF6Ii8+DQo8L3N2Zz4NCg==";
export { SvgStarV1 as ReactComponent };